import React from 'react';


const savedAddressContext = React.createContext({});

const { Provider, Consumer } = savedAddressContext;

export const SavedAddressContextProvider = Provider;

export const SavedAddressContextConsumer = Consumer;

export const SavedAddressContext = savedAddressContext;
